﻿import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
    Box,
    Grid,
    Switch,
    FormControlLabel,
    FormGroup,
    Collapse,
    Tooltip,
    Paper,
} from '@mui/material';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import TimeHelper from '../../../../utils/time';
import { CPREF } from './communicationPreference.classes';

interface IProps {
    infoList: any;
    info: any;
    labelText: string;
    switchStatusObject?: any;
    setSwitchStatusObject: any;
    statusName?: any;
}

export const CommunicationPreferenceGrid: FC<IProps> = ({
    infoList,
    info,
    labelText,
    switchStatusObject,
    setSwitchStatusObject,
    statusName,
}) => {
    const { t } = useTranslation();
    const [openC, setOpenC] = useState(false);
    const [pageSize, setPageSize] = useState(5);
    const handleChange = (event: any) => {
        setSwitchStatusObject({ ...switchStatusObject, [statusName]: event.target.checked });
    };
    const columns: ExtendedGridColDef[] = [
        { field: 'date', headerName: t('general.date'), flex: 1 },
        { field: 'source', headerName: t('customerInformation.source'), flex: 1 },
        { field: 'platform', headerName: 'Platform', flex: 1 },
        { field: 'state', headerName: t('orderDetail.status'), flex: 1 },
        {
            field: 'validateNumber',
            headerName: t('customerInformation.allowedValue'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={<h2>{params.row.validateNumber}</h2>}>
                            <p>{params.row.validateNumber}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'ip', headerName: t('customerInformation.ipAddress'), flex: 1 },
        {
            field: 'device',
            headerName: t('customerInformation.device'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={<h2>{params.row.device}</h2>}>
                            <p>{params.row.device}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
    ];
    return (
        <Paper
            className={CPREF.gridCard}
            onClick={() => {
                setOpenC((prevOpen: boolean) => !prevOpen);
            }}
            style={{
                borderRadius: '10px',
                boxShadow: '0px -4px 6px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.1)',
            }}
        >
            <Grid
                className={CPREF.gridToolbar}
                container
                justifyContent={'space-between'}
                sx={{ marginTop: '2rem', padding: '1rem' }}
            >
                <Grid
                    className={CPREF.gridToolbarInner}
                    container
                    alignItems={'center'}
                    sx={{ padding: '8px' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Grid
                        className={CPREF.fieldPreferenceSwitch}
                        size={{
                            xl: 2,
                            lg: 2,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <FormGroup>
                            <FormControlLabel
                                onClick={(e) => e.stopPropagation()}
                                control={
                                    <Switch
                                        className={CPREF.inputSwitchPreference}
                                        checked={switchStatusObject[statusName]}
                                        onChange={handleChange}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                }
                                label={labelText}
                            />
                        </FormGroup>
                    </Grid>
                    <Grid
                        className={CPREF.blockLastUpdated}
                        container
                        sx={{ marginLeft: '2rem' }}
                        size={{
                            xl: 4,
                            lg: 4,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <Grid
                            sx={{ marginLeft: '1rem' }}
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <b> {t('customerInformation.lastChangeDate')}</b>
                        </Grid>

                        <Grid
                            sx={{ marginLeft: '1rem' }}
                            size={{
                                xl: 4,
                                lg: 4,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <p style={{ fontSize: '12px', width: 'max-content' }}>
                                {TimeHelper.formatDateHour(info.lastUpdatedDate)}
                            </p>
                        </Grid>
                    </Grid>

                    <Grid
                        className={CPREF.blockPlatform}
                        sx={{ marginLeft: '1rem' }}
                        direction="column"
                        size={{
                            xl: 2,
                            lg: 2,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <Grid
                            container
                            size={{
                                xl: 2,
                                lg: 2,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <b>Platform</b>
                        </Grid>
                        <Grid
                            container
                            size={{
                                xl: 2,
                                lg: 2,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            {info.lastUpdatedProject}
                        </Grid>
                    </Grid>

                    <Grid
                        className={CPREF.toggleDetailRow}
                        container
                        display="flex"
                        justifyContent={'flex-end'}
                        sx={{ marginTop: '2rem' }}
                        size={{
                            xl: 2,
                            lg: 2,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <p className={CPREF.inputToggleDetail} style={{ color: '#0d6efd', cursor: 'pointer' }}>
                            <b>
                                {' '}
                                {t('general.showDetail')}{' '}
                                {openC === true ? (
                                    <ExpandLess width="24px" height="24px" />
                                ) : (
                                    <ExpandMore width="24px" height="24px" />
                                )}
                            </b>
                        </p>
                    </Grid>
                    <Grid
                        className={CPREF.collapseSection}
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <Collapse in={openC}>
                            <Box className={CPREF.datagrid}>
                                <SCUICustomDataGrid
                                    randomId
                                    rows={infoList}
                                    columns={columns}
                                    pageSize={pageSize}
                                    onPageSizeChange={(i: number) => {
                                        setPageSize(i);
                                    }}
                                ></SCUICustomDataGrid>
                            </Box>
                        </Collapse>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

